let $popup = null;

function createPopup(imageUrl) {
    let $newPopup = $(
        `<div class="image-popup"><img class="image" src="${imageUrl}"/></div>`
    );

    $newPopup.click(() => closePopup());
    $newPopup.appendTo('body');

    return $newPopup;
}

function openPopup(imageUrl) {
    if ($popup === null) {
        $popup = createPopup(imageUrl);
    } else {
        const $img = $popup.children('img');

        $img.attr('src', imageUrl);
    }

    $popup.css({display: 'block'});
}

export function closePopup() {
    $popup.css({display: 'none'});
}

export default openPopup;
